import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";
import ComponentManager from '@/Management/ComponentManager';
import OptionsLandschaftGroupT from '@/Controls/OptionsLandschaftGroup';

export default class OptionsLandschaftsGroupsBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.optionsLandschaftGroups = {
            update: (node: HTMLElement, valueAccessor: () => any) => {
                let OptionsLandschaftGroup = ComponentManager.getControl<typeof OptionsLandschaftGroupT>('OptionsLandschaftGroup');

                let optionsLandschaft = $(node);
                let options = valueAccessor();
                let groups = options.groups();

                if (options.parent.groups != null) {
                    for (let i = 0; i < options.parent.groups.length; i++) {
                        options.parent.groups[i].dispose();
                        options.parent.groups[i] = null;
                    }
                }

                optionsLandschaft.empty();
                options.parent.groups = [];

                for (let i = 0; i < groups.length; i++) {
                    let optionsLandschaftGroup = new OptionsLandschaftGroup(groups[i], $('<div>').appendTo(optionsLandschaft));
                    let tuple = optionsLandschaftGroup.getTuple();

                    options.parent.groups.push(optionsLandschaftGroup);
                }
            }
        };
    }
}